/*
 * A meeting request's marker (LEA-494, docs/2026-11-03-meeting-request-row.md): the Interested
 * replies whose newest message asks to meet. It sits beside the label and is never a label of its
 * own, so it is drawn as the Data request marker is, a tag and not a pill: in Interested's own ink,
 * with a calendar mark, and never the mark alone. A pill with a ring is what a closed label looks
 * like (`label-key.tsx`), which a meeting request is not. Its own file, as `label-key.tsx` is
 * imported by `icons.tsx` and so cannot import an icon itself.
 */
import { CalendarIcon } from "../icons.tsx";
import { LABEL_KEYS } from "./labels.ts";

/** What a meeting request means, said by the marker's tip where nothing more is known. */
const MEETING_REQUEST_NOTE = "The newest reply asks to meet, proposes a time or asks how to book";

/** The marker; `note` says where the flag came from (the AI, or who marked it), else what it means. */
export function MeetingRequestMarker(props: { note?: string | undefined }) {
  const note = props.note ?? MEETING_REQUEST_NOTE;
  return (
    <span className="lcr-meeting-request" data-label-key={LABEL_KEYS.interested} title={note}>
      <CalendarIcon size={12} />
      Meeting request<span className="lcr-visually-hidden">: {note}</span>
    </span>
  );
}
